import { Injectable, signal } from '@angular/core';

export type ToastTone = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  tone: ToastTone;
  title?: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;
  readonly toasts = signal<Toast[]>([]);

  success(message: string, title?: string): void { this.push('success', message, title); }
  error(message: string, title?: string): void   { this.push('error', message, title); }
  info(message: string, title?: string): void    { this.push('info', message, title); }

  dismiss(id: number): void {
    this.toasts.update(list => list.filter(t => t.id !== id));
  }

  private push(tone: ToastTone, message: string, title?: string): void {
    const id = this.nextId++;
    this.toasts.update(list => [...list, { id, tone, title, message }]);
    setTimeout(() => this.dismiss(id), tone === 'error' ? 6000 : 3500);
  }
}
